import { Component, Inject } from '@angular/core';
import { MatButtonModule } from "@angular/material/button";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-payment-confirmed',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, CommonModule, TranslateModule],
  templateUrl: './modal-payment-confirmed.component.html',
  styleUrl: './modal-payment-confirmed.component.scss'
})
export class ModalPaymentConfirmedComponent {


  constructor(public dialogRef: MatDialogRef<ModalPaymentConfirmedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      console.log(this.data);

  }

  close(){
    this.dialogRef.close();
  }

  assingUser(){
    this.dialogRef.close(true);
  }

}
